@if (content.type === 'TextContent') {
  <wm-editable-text class="content text" [supportedEditModes]="['visual', 'html']" [(ngModel)]="content.text" (ngModelChange)="updateContent()"></wm-editable-text>
}
@if (content.type === 'ImageContent') {
  <div class="content image">
    @if (content.imageURLOrBlob['blobId']; as blobId) {
      <img [src]="getBlobUrl(blobId)" [alt]="content.imageAltText || ''">
    }
    @if (content.imageURLOrBlob['url']; as url) {
      <img [src]="url" [alt]="content.imageAltText || ''">
    }
  </div>
}
@if (content.type === 'ChartContent') {
  <div class="content chart">
    @if (content.chartData.type === 'DonutChartData') {
      <div class="form-item">
        <div class="form-label tiny">Type</div>
        <div>Donut</div>
      </div>
      <div class="form-item">
        <div class="form-label tiny">Data</div>
        <div class="chart-data">
          @for (data of content.chartData.data; track data) {
            <div class="chart-data-item">
              <div class="label">{{ data.label }}</div>
              <div class="value">{{ data.value }}</div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
@if (content.type === 'TableContent') {
  <div class="content table">
    <table>
      <tbody>
        @for (row of content.rows; track row) {
          <tr>
            @for (cell of row; track cell) {
              @if (cell.isHeader) {
                <th>
                  <wm-editable-inlinetext (onSave)="updateContent()" [(ngModel)]="cell.content"></wm-editable-inlinetext>
                </th>
              }
              @if (!cell.isHeader) {
                <td>
                  <wm-editable-inlinetext (onSave)="updateContent()" [(ngModel)]="cell.content"></wm-editable-inlinetext>
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (content.type === 'ContentContainer') {
  <div class="content container">
    @for (subContent of content.children; track subContent) {
      <wm-report-section-content class="container-item" (onContentUpdate)="updateContent()" [content]="subContent" [reportId]="reportId"></wm-report-section-content>
    }
  </div>
}
